const intro = (
  <p>
    <strong>Webinary</strong> Remedium to swoiste szkolenia on-line, w ramach
    których zapraszamy ekspertów wszelkich dziedzin z zakresu medycyny, aby
    budować bazę rzetelnej, najnowszej i niezbędnej wiedzy dla lekarzy i lekarek
    z całej Polski.
  </p>
);

const content = (
  <>
    <h3>Aktualna wiedza w formie wideo</h3>
    <p>
      Regularnie przeprowadzamy zdalne wydarzenia medyczne na różne merytoryczne
      tematy. Zapraszamy medyków do uczestniczenia w nich na żywo, jednak zapisy
      wszystkich spotkań publikujemy na platformie Remedium.{" "}
    </p>
    <h3>Wydarzenia on-line dla lekarzy</h3>
    <p>
      Edukacyjne “seminaria”, do których możesz dołączyć zawsze, kiedy
      potrzebujesz, a także nagrania opublikowane dla wszystkich lekarek i
      lekarzy.
    </p>
  </>
);

export const videoWebinarDescription = { intro, content };
